import React, { useEffect, useMemo, useState } from "react";
import { Box, TreeView } from "@primer/react";
import { HomeIcon, DotIcon, FileDirectoryIcon, PeopleIcon } from "@primer/octicons-react";
import { useCommonContext } from "../../contexts/common";
import { dm_phong } from "../../models/response/phong/dm_phong";

interface PhongTreeViewProps {
  dataSource: dm_phong[];
  height?: number;
  selectedValue?: { phongId: number };
  onSelectionChanged: (phongId: number, ten_phong: string) => void;
}

const PhongTreeView: React.FC<PhongTreeViewProps> = ({
  dataSource,
  height,
  selectedValue,
  onSelectionChanged,
}) => {
  const { translate } = useCommonContext();

  const formattedData = useMemo(() => {
    const unassignedRoom = {
      key: 'unassigned',
      text: 'Chưa xếp phòng',
      items: [],
    };

    const buildings = Array.from(new Set(dataSource.map((x) => x.toa)));
    const buildingNodes = buildings.map((toa) => ({
      key: `toa-${toa}`,
      text: toa,
      items: dataSource
        .filter((phong) => phong.toa === toa)
        .map((phong) => ({
          key: `phong-${phong.id}`,
          id: phong.id,
          text: phong.ten_phong,
        })),
    }));

    return [unassignedRoom, ...buildingNodes];
  }, [dataSource]);

  return (
    <Box
      sx={{
        height: height ?? "calc(100vh - 182px)",
        overflow: "auto",
        pl: 2,
      }}
    >
      <nav aria-label="Rooms">
        <TreeView aria-label="Rooms">
          {formattedData.map((building) => (
            <TreeView.Item key={building.key} id={building.key} defaultExpanded>
              <TreeView.LeadingVisual>
                {building.key === 'unassigned' ? <PeopleIcon /> : <TreeView.DirectoryIcon />}
              </TreeView.LeadingVisual>
              <Box 
                as="span" 
                onClick={() => building.key === 'unassigned' && onSelectionChanged(-1, 'Chưa xếp phòng')}
                sx={{ cursor: building.key === 'unassigned' ? 'pointer' : 'default' }}
              >
                {building.text}
              </Box>
              {building.items.length > 0 && (
                <TreeView.SubTree>
                  {building.items.map((room) => (
                    <TreeView.Item
                      key={room.key}
                      id={room.key}
                      onSelect={() => onSelectionChanged(room.id, room.text)}
                      current={room.id === selectedValue?.phongId}
                    >
                      <TreeView.LeadingVisual>
                        <FileDirectoryIcon />
                      </TreeView.LeadingVisual>
                      {room.text}
                    </TreeView.Item>
                  ))}
                </TreeView.SubTree>
              )}
            </TreeView.Item>
          ))}
        </TreeView>
      </nav>
    </Box>
  );
};

export default PhongTreeView;